<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row
          v-for="measure in measures"
          :key="measure._id"
          justify="space-between"
          no-gutters
        >
          <v-col cols="2">
            <v-text-field v-model="measure.number" height="10" filled>
            </v-text-field>
          </v-col>
          <v-col cols="8">
            <v-text-field v-model="measure.availability" outlined>
              <template v-slot:prepend>
                <v-icon color="red" @click="measure.availability -= 1"
                  >mdi-minus-circle</v-icon
                >
              </template>
              <template v-slot:append-outer>
                <v-icon color="green" @click="measure.availability += 1"
                  >mdi-plus-circle</v-icon
                >
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-btn @click="addMeasure" text color="primary"
          ><v-icon small>mdi-plus-circle</v-icon> Aggiungi</v-btn
        >
      </v-col>
      <v-col>
        <v-btn class="save" color="green" dark @click="save">Salva</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ["value"],
  data: function() {
    return {
      measures: this.value
    };
  },
  methods: {
    parseNumber(num) {
      return Number.parseFloat(`${num}`.replace(",", ".").replace(" ", ""));
    },
    save: function() {
      let measures = [];
      for (let measure of this.measures) {
        measures.push({
          number: this.parseNumber(measure.number),
          availability: measure.availability
        });
      }
      this.$emit("input", measures);
    },
    addMeasure: function() {
      this.measures.push({ number: 0, availability: 0 });
    }
  }
};
</script>

<style scoped>
.save {
  width: 100%;
  margin: 0 auto;
}
</style>
